import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentDeleteFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 5a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H8l-5 5V5Zm17.06 2.56-3.939 3.94 3.94 3.94-2.122 2.12L14 13.622l-3.94 3.94-2.12-2.122 3.939-3.939-3.94-3.94 2.122-2.12L14 9.378l3.94-3.94 2.12 2.122Z"
    />
  </svg>
);
export default IconCommentDeleteFilledSizeL;
